<template>
	<div>
		<div class="authPage__text">
			<div class="authPage__title">
				<div class="authPage__titleLine1">
					{{
						$t("registerTitleLine1", {
							brandName,
						})
					}}
				</div>
				<div class="authPage__titleLine2">
					{{
						$t("registerTitleLine2", {
							brandName,
						})
					}}
				</div>
			</div>
			<div class="authPage__lead">
				{{
					$t(
						"Insira suas informações nos campos abaixo para se registar no simulador."
					)
				}}
			</div>
		</div>

		<ValidationObserver v-slot="{ handleSubmit }">
			<form
				class="authPage__form"
				@submit.prevent="handleSubmit(handleValidSubmit)"
			>
				<div class="mb-60">
					<div
						class="d-grid--2"
						:style="{
							'--column-gap': '20px',
							'--row-gap': '30px',
						}"
					>
						<ValidationProvider rules="required" v-slot="{ errors }">
							<BFieldBlock :label="$t('Nome')">
								<BFieldText
									v-model="form.firstName"
									:placeholder="$t('Qual é o seu primeiro nome')"
									:state="errors.length ? 'error' : undefined"
									:helperText="errors.length ? $t(errors[0]) : undefined"
								/>
							</BFieldBlock>
						</ValidationProvider>

						<ValidationProvider rules="required" v-slot="{ errors }">
							<BFieldBlock :label="$t('Apelido')">
								<BFieldText
									v-model="form.lastName"
									:placeholder="$t('Qual é o seu apelido')"
									:state="errors.length ? 'error' : undefined"
									:helperText="errors.length ? $t(errors[0]) : undefined"
								/>
							</BFieldBlock>
						</ValidationProvider>

						<ValidationProvider rules="required|email" v-slot="{ errors }">
							<BFieldBlock :label="$t('E-mail')">
								<BFieldText
									v-model="form.email"
									:placeholder="$t('Insira o e-mail')"
									:state="errors.length ? 'error' : undefined"
									:helperText="errors.length ? $t(errors[0]) : undefined"
								/>
							</BFieldBlock>
						</ValidationProvider>

						<ValidationProvider rules="required" v-slot="{ errors }">
							<BFieldBlock :label="$t('Empresa')">
								<BFieldText
									v-model="form.company"
									:placeholder="$t('Insira a empresa')"
									:state="errors.length ? 'error' : undefined"
									:helperText="errors.length ? $t(errors[0]) : undefined"
								/>
							</BFieldBlock>
						</ValidationProvider>

						<div
							class="o-stack"
							:style="{
								'--gap': '20px',
							}"
						>
							<ValidationProvider
								rules="required|strong_password"
								v-slot="{ errors }"
							>
								<BFieldBlock :label="$t('Password')">
									<BFieldText
										:placeholder="$t('Insira a password')"
										type="password"
										v-model="form.password"
										:state="errors.length ? 'error' : undefined"
									/>
								</BFieldBlock>
							</ValidationProvider>

							<PasswordStrengthMeter :password="form.password" />
						</div>

						<ValidationProvider
							:rules="{
								required: true,
								is: form.password,
							}"
							v-slot="{ errors }"
						>
							<BFieldBlock :label="$t('Confirme password')">
								<BFieldText
									:placeholder="$t('Repita a password')"
									v-model="form.confirmPassword"
									type="password"
									:state="errors.length ? 'error' : undefined"
									:helperText="errors.length ? $t(errors[0]) : undefined"
								/>
							</BFieldBlock>
						</ValidationProvider>
					</div>
				</div>

				<div class="authPage__mainExpandedFormFooter justify-between">
					<ValidationProvider rules="required">
						<BCheckbox v-model="form.termsAccepted">
							<template #label>
								<span
									v-html="
										$t('Eu aceito os ${termsAndConditions}', {
											termsAndConditions: `<a class='t-link' href='#'>${$t(
												'termos e condições'
											)}</a>`,
										})
									"
								></span>
							</template>
						</BCheckbox>
					</ValidationProvider>
					<BBtn :disabled="!form.termsAccepted">
						{{ $t("Criar Conta") }}
					</BBtn>
				</div>
			</form>
		</ValidationObserver>
	</div>
</template>

<script>
import { mapActions } from "vuex";

import BIcon from "@/components/base/BIcon";
import BBtn from "@/components/base/BBtn";
import BFieldBlock from "@/components/base/BFieldBlock";
import BFieldText from "@/components/base/BFieldText";
import BCheckbox from "@/components/base/BCheckbox";

import PasswordStrengthMeter from "./PasswordStrengthMeter.vue";

import { ValidationProvider, ValidationObserver } from "vee-validate";

import branding from "@/branding";

export default {
	components: {
		BIcon,
		BBtn,
		BFieldBlock,
		BFieldText,
		BCheckbox,
		PasswordStrengthMeter,
		ValidationProvider,
		ValidationObserver,
	},
	data() {
		return {
			brandName: branding.BRAND_NAME,
			form: {
				termsAccepted: false,
				firstName: "",
				lastName: "",
				email: "",
				company: "",
				password: "",
				confirmPassword: "",
			},
		};
	},
	methods: {
		...mapActions("user", ["createAccount"]),

		handleValidSubmit(e) {
			const {
				termsAccepted,
				confirmPassword,
				...createAccountData
			} = this.form;

			this.createAccount({
				...createAccountData,
				userName: createAccountData.email,
			})
				.then(() => {
					this.$notify({
						type: "success",
						title:
							"Conta criada com sucesso. Verifique o seu email para ativar a conta.",
					});

					this.$router.push({
						name: "Login",
					});
				})
				.catch((err) => {
					this.$notify({
						type: "error",
						title:
							err?.response?.data?.details?.[0]?.description ??
							"Erro ao Criar Conta",
					});
				});
		},
	},

	computed: {
		isConfirmPasswordValid() {
			return this.password === this.confirmPassword;
		},
	},
};
</script>
